<template>
  <div class="setting">
    <v-container>
      <h2 class="mb-2">Settings</h2>
      <div class="test">
        <p>クライアント毎の設定</p>
      </div>
      <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
      <div v-if="isLoading" align="center">
        <v-progress-circular
          :size="250"
          color="primary"
          indeterminate
          align="center"
        ></v-progress-circular>
      </div>
      <div v-else>
        <!--
      <v-row>
        <v-col cols="12" sm="6">
          <h3 class="mb-2">Github リポジトリ</h3>
          <v-text-field
            v-model="json.repository"
            :class="[`mb-4`]"
            placeholder="Github のリポジトリURLを入力してください"
            background-color="white"
            outlined
            hide-details="auto"
          ></v-text-field>
          <h3 class="mb-2">Githubプッシュ先ディレクトリ</h3>
          <v-text-field
            v-model="json.directroy"
            :class="[`mb-4`]"
            placeholder="ディレクトリパス"
            background-color="white"
            outlined
            hide-details="auto"
          ></v-text-field>
          <hr />
          <h3 class="mb-2">生成するページID</h3>
          <v-text-field
            v-model="json.pageID"
            :class="[`mb-4`]"
            placeholder="ページID"
            background-color="white"
            outlined
            hide-details="auto"
          ></v-text-field>
          <h3 class="mb-2">生成コンポーネント名</h3>
          <v-text-field
            v-model="json.component"
            :class="[`mb-4`]"
            placeholder="コンポーネント名を入力してください"
            background-color="white"
            outlined
            hide-details="auto"
          ></v-text-field>
          <h3 class="mb-2">コミットコメント</h3>
          <v-textarea
            v-model="json.message"
            :class="[`mb-4`]"
            placeholder="コミット内容を記述"
            background-color="white"
            outlined
            rows="4"
            hide-details="auto"
          ></v-textarea>
        </v-col>
      </v-row>
      -->
        <!--
      <v-row justify="center" class="mt-4">
        <v-btn @click="componentGenerate" color="primary"
          >コンポーネント生成</v-btn
        >
      </v-row>
      <v-row justify="center" class="mt-4">
        <v-btn @click="gitPush" color="primary">コンポーネントのプッシュ</v-btn>
      </v-row>
       -->
        <v-row justify="center" class="ma-4">
          <v-btn @click="AllcomponentGenerate" color="primary"
            >vue Routerの生成&全ページの生成</v-btn
          >
        </v-row>
        <v-row justify="center" class="ma-4">
          <v-col cols="3">
            <v-select
              :items="branchSelect"
              v-model="json.branch"
              label="対象ブランチ"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-btn @click="AllcomponentDeploy" color="primary" disabled
              >全コンポーネントのデプロイ</v-btn
            >
          </v-col>
        </v-row>
        <v-row justify="center" class="ma-4">
          <v-btn @click="ProductionTransition" color="primary"
            >本番環境へデータの反映</v-btn
          >
        </v-row>
        <v-dialog
          v-if="movecheck_dialog"
          v-model="movecheck_dialog"
          max-width="400"
        >
          <movecheck-dialog
            v-on:clickSubmit="modalClose"
            :message="messege"
            :tag="tag"
            :type="type"
          />
        </v-dialog>
        <v-dialog v-if="check_dialog" v-model="check_dialog" max-width="400">
          <check-dialog
            v-on:clickSubmit="modalClose"
            :message="messege"
            :tag="tag"
            :type="type"
          />
        </v-dialog>
      </div>
    </v-container>
  </div>
</template>
<script>
import checkDialog from "../../components/CheckDialog/CheckDialog";
import movecheckDialog from "../../components/CheckDialog/CustomerMoveCheckDialog";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  name: "Index",
  components: {
    checkDialog,
    movecheckDialog,
  },
  data: () => ({
    messege: "モーダルメッセージ",
    tag: "",
    type: "",
    drawer: true,
    json: {
      repository: "ide_demo2",
      directroy: "src/views",
      pageID: -1,
      component: "test.vue",
      customerID: 0,
      message: "commit message",
      branch: "localDemo",
    },
    movecheck_dialog: false,
    check_dialog: false,
    isLoading: false,
    //
    branchSelect: ["develop", "localDemo", "TempView"],
    //
    MoveReports: [],
  }),
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {
      this.$store.state.customerID = Number(this.$route.params.id);
    },
    async componentGenerate() {
      this.isLoading = true;
      const result = await api.componentGenerate(this.json);
      if (result == false) {
        alert("生成失敗");
      } else {
        alert("完了");
      }
      alert("完了");
      this.isLoading = false;
    },
    async gitPush() {
      const result = await api.gitPush(this.json);
      if (result == null) {
        alert("デプロイ失敗");
      } else {
        alert("完了");
      }
    },
    async AllcomponentGenerate() {
      try {
        this.isLoading = true;
        this.json.customerID = this.$store.state.customerID;
        const result = await api.AllGenerate(this.json);
        console.log(result.data);
        if (result.data.errors != null) {
          alert("生成失敗\n" + result.data.errors);
        } else {
          alert("生成完了");
        }
      } catch (e) {
        console.log("err", e);
        alert("生成に失敗しました。");
      }
      this.isLoading = false;
    },
    //-----------------------------------------------------------------------
    AllcomponentDeploy() {
      this.modalOpen("AllcomponentDeploy", "デプロイしますか?");
    },
    ProductionTransition() {
      let id = this.$store.state.customerID;
      if (id != 0 && id != null && this.$store.state.customerName != "") {
        this.modalOpen(
          "ProductionTransition",
          this.$store.state.customerName + "のデータを本番環境へ反映しますか?"
        );
      } else {
        alert("customerNameが存在しません。homeへ戻ります");
        this.$router.push({
          path: "/",
        });
      }
    },
    //
    modalOpen(tag, message, type) {
      this.messege = message;
      this.tag = tag;
      this.type = type;
      if (tag == "ProductionTransition_2") {
        this.movecheck_dialog = true;
      } else {
        this.check_dialog = true;
      }
    },
    async modalClose(bool, tag, returnData) {
      this.isLoading = true;
      switch (tag) {
        case "AllcomponentDeploy":
          if (bool) {
            this.AllcomponentDeploy();
            try {
              this.json.customerID = this.$store.state.customerID;
              const response = await api.AllDeploy(this.json);
              if (response.data.message != "success") {
                alert("デプロイ失敗:" + response.data.message);
              } else {
                alert("完了");
              }
            } catch (e) {
              alert("デプロイ失敗");
              console.log(e);
            }
          }
          this.check_dialog = false;
          break;
        case "ProductionTransition":
          if (bool) {
            this.check_dialog = false;
            this.modalOpen(
              "ProductionTransition_2",
              this.$store.state.customerName + "で間違いないですか?",
              "important"
            );
          } else {
            this.check_dialog = false;
          }
          break;
        case "ProductionTransition_2":
          console.log(returnData.MoveReprots);
          if (bool) {
            let json = {
              //customerID: 1,
              //customerName: "test",
              customerID: this.$store.state.customerID,
              customerName: this.$store.state.customerName,
              MoveReports: returnData.MoveReprots,
            };
            try {
              const res = await api.ProductionTransition(json);
              if (res.result == "Success") {
                alert("本番環境のデータコピー完了");
              } else {
                alert("本番環境のデータコピー失敗\n" + res.message);
              }
            } catch (e) {
              console.log(e);
            }
          } else {
            console.log("キャンセル");
          }
          this.movecheck_dialog = false;
          break;
        default:
          console.log("ather");
          this.check_dialog = false;
      }
      this.isLoading = false;
    },
    back() {
      history.back();
    },
  },
};
</script>
